import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';

import { InitialValues, ValidationErrors } from 'forms/types';
import {
  composeValidators,
  isDateInPast,
  isDOBRangeValid,
  isPresent,
  isGreaterOrEqual,
  getTodayDateTime,
} from 'forms/validators';

import { BasicsFormValues } from '../form/types';

export const createValidate =
  (isPageConsolidationEnabled: boolean) =>
  ({
    gender,
    stateId,
    dateOfBirth,
    job,
    atLeast30HoursAWeek,
    selfEmployed,
    corporateStructure,
    ownershipStake,
    numberOfEmployees,
    numberOfPartners,
    companyFoundedAt,
    annualIncomeBeforeCompany,
    becameOwnerAt,
    disabilityInsuranceStatus,
    existingCoverage,
    disabilityInsuranceSource,
    intendToReplace,
    employerPaysPremium,
  }: InitialValues<BasicsFormValues>): ValidationErrors<BasicsFormValues> => {
    const dateValidator = composeValidators(isPresent, isDateInPast, isDOBRangeValid);

    const errors: ValidationErrors<BasicsFormValues> = {
      gender: isPresent(gender),
      stateId: isPresent(stateId),
      dateOfBirth: dateValidator(dateOfBirth),
    };

    if (isPageConsolidationEnabled) {
      errors.job = isPresent(job);
      errors.atLeast30HoursAWeek = isPresent(atLeast30HoursAWeek);

      errors.selfEmployed = isPresent(selfEmployed);
      errors.disabilityInsuranceStatus = isPresent(disabilityInsuranceStatus);

      if (selfEmployed) {
        const atLeast0 = composeValidators(isPresent, isGreaterOrEqual(0));

        errors.corporateStructure = isPresent(corporateStructure);
        errors.ownershipStake = isPresent(ownershipStake);
        errors.numberOfEmployees = atLeast0(numberOfEmployees);
        errors.numberOfPartners = atLeast0(numberOfPartners);
        errors.companyFoundedAt = isPresent(companyFoundedAt);
        errors.becameOwnerAt = isPresent(becameOwnerAt);

        if (companyFoundedAt && companyFoundedAt >= getTodayDateTime().year - 1) {
          errors.annualIncomeBeforeCompany = isPresent(annualIncomeBeforeCompany);
        }
      }

      if (disabilityInsuranceStatus) {
        const existingCoverageValidator = composeValidators(isPresent, isGreaterOrEqual(1));

        errors.disabilityInsuranceSource = isPresent(disabilityInsuranceSource);
        errors.intendToReplace = isPresent(intendToReplace);
        errors.existingCoverage = existingCoverageValidator(existingCoverage);

        if (disabilityInsuranceSource === 'employer') {
          errors.employerPaysPremium = isPresent(employerPaysPremium);
        }
      }
    }

    return omitBy(errors, isNil);
  };
